const RATES_API = "https://api.frankfurter.dev/v1/latest";

/**
 * Fetch how many units of `currency` one GBP is worth (GBP -> currency).
 * Returns 1 for GBP itself (no conversion needed) — using live ECB-sourced
 * rates (frankfurter.dev — free, no API key, CORS-enabled). Rates update
 * once a day on frankfurter's end (ECB reference rates), not real-time —
 * fine for reconciliation, not for anything time-sensitive.
 *
 * @param {string} currency - target currency code, e.g. "USD"
 * @returns {Promise<number|null>} rate, or null if Shopify/frankfurter has
 *   no data for it
 */
export async function fetchGbpToCurrencyRate(currency) {
  if (currency === "GBP") return 1;

  const response = await fetch(`${RATES_API}?base=GBP&symbols=${currency}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch exchange rate (${response.status})`);
  }

  const data = await response.json();
  return data.rates?.[currency] ?? null;
}